<template>
  <div :class="{
      'has-error': hasErrors,
      'disabled': disabled,
    }">
    <el-radio @change="onChange" :value="value" :name="name" :disabled="disabled" :label="label" :required="required">
      <slot>{name}</slot>{{ required ? ' *' : '' }}
    </el-radio>

    <div v-if="hasErrors" class="form-group__errors">
      <p>{{ errors[0] }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SaxxRadio",
  props: {
    form: {
      required: true,
      type: String
    },
    name: {
      required: true,
      type: String
    },
    label: {
      required: true,
      type: String
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters("forms", ["getField", "getErrors", "getFieldIsDisabled"]),
    value() {
      return this.getField({
        form: this.form,
        field: this.name
      });
    },
    errors() {
      return this.getErrors({
        form: this.form,
        field: this.name
      });
    },
    hasErrors() {
      return this.errors.length > 0;
    },
    disabled() {
      return this.getFieldIsDisabled({ form: this.form, field: this.name });
    }
  },
  methods: {
    ...mapActions("forms", ["setField"]),
    onChange() {
      this.setField({
        form: this.form,
        field: this.name,
        value: this.label
      });
    }
  }
};
</script>
